__turbopack_context__.v({
  "bat-image": "styles-module__xDlpAG__bat-image",
  "fly-right": "styles-module__xDlpAG__fly-right",
  "leaf": "styles-module__xDlpAG__leaf",
  "leaf-fall": "styles-module__xDlpAG__leaf-fall",
  "seasonal-wrapper": "styles-module__xDlpAG__seasonal-wrapper",
  "snow-fall": "styles-module__xDlpAG__snow-fall",
  "snow-flake": "styles-module__xDlpAG__snow-flake",
});
